// import { PorfileNavigation } from './types';
export const errorMessageStyle = 'text-sm text-red-600 mt-1';
export const buttonStyle =
  'px-6 py-1 border border-primary text-primary rounded shadow';
export const initialNavigation = [
  {
    id: 1,
    text: 'Personal Information',
    icon: (
      <svg
        width='17'
        height='17'
        viewBox='0 0 17 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M8.33268 2.33398C9.21674 2.33398 10.0646 2.68517 10.6897 3.31029C11.3148 3.93542 11.666 4.78326 11.666 5.66732C11.666 6.55137 11.3148 7.39922 10.6897 8.02434C10.0646 8.64946 9.21674 9.00065 8.33268 9.00065C7.44863 9.00065 6.60078 8.64946 5.97566 8.02434C5.35054 7.39922 4.99935 6.55137 4.99935 5.66732C4.99935 4.78326 5.35054 3.93542 5.97566 3.31029C6.60078 2.68517 7.44863 2.33398 8.33268 2.33398ZM8.33268 10.6673C12.016 10.6673 14.9993 12.159 14.9993 14.0007V15.6673H1.66602V14.0007C1.66602 12.159 4.64935 10.6673 8.33268 10.6673Z'
          fill='#171717'
        />
      </svg>
    ),
    view: true,
    complete: false,
  },
  {
    id: 2,
    text: 'Education',
    icon: (
      <svg
        width='21'
        height='20'
        viewBox='0 0 21 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M10.6667 2.5L1.5 7.5L10.6667 12.5L18.1667 8.40833V14.1667H19.8333V7.5M4.83333 10.9833V14.3167L10.6667 17.5L16.5 14.3167V10.9833L10.6667 14.1667L4.83333 10.9833Z'
          fill='black'
        />
      </svg>
    ),
    view: false,
    complete: false,
  },
  {
    id: 3,
    text: 'Experiences',
    icon: (
      <svg
        width='19'
        height='20'
        viewBox='0 0 19 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M16.8327 9.25898V5.83398C16.8327 5.39196 16.6571 4.96803 16.3445 4.65547C16.032 4.34291 15.608 4.16732 15.166 4.16732H11.8327V2.50065C11.8327 2.05862 11.6571 1.6347 11.3445 1.32214C11.032 1.00958 10.608 0.833984 10.166 0.833984H6.83268C6.39066 0.833984 5.96673 1.00958 5.65417 1.32214C5.34161 1.6347 5.16602 2.05862 5.16602 2.50065V4.16732H1.83268C1.39065 4.16732 0.966732 4.34291 0.654171 4.65547C0.34161 4.96803 0.166016 5.39196 0.166016 5.83398V15.0007C0.166016 15.4427 0.34161 15.8666 0.654171 16.1792C0.966732 16.4917 1.39065 16.6673 1.83268 16.6673H7.88268C8.34073 17.3363 8.9332 17.9024 9.62228 18.3296C10.3114 18.7568 11.0819 19.0357 11.8848 19.1484C12.6877 19.2611 13.5053 19.2052 14.2854 18.9843C15.0654 18.7634 15.7909 18.3823 16.4154 17.8653C17.04 17.3484 17.5499 16.7069 17.9127 15.9818C18.2755 15.2567 18.4831 14.464 18.5224 13.6542C18.5616 12.8444 18.4316 12.0353 18.1407 11.2785C17.8498 10.5218 17.4043 9.83395 16.8327 9.25898ZM6.83268 2.50065H10.166V4.16732H6.83268M15.166 16.6673C14.4448 17.2082 13.5676 17.5007 12.666 17.5007C11.7645 17.5007 10.8872 17.2082 10.166 16.6673C9.46641 16.1426 8.94963 15.4111 8.68888 14.5763C8.42813 13.7416 8.43662 12.846 8.71317 12.0164C8.98971 11.1867 9.52028 10.4651 10.2297 9.95381C10.9392 9.44247 11.7915 9.16732 12.666 9.16732C13.5405 9.16732 14.3929 9.44247 15.1023 9.95381C15.8117 10.4651 16.3423 11.1867 16.6189 12.0164C16.8954 12.846 16.9039 13.7416 16.6432 14.5763C16.3824 15.4111 15.8656 16.1426 15.166 16.6673ZM11.8327 10.834H13.0827V13.184L15.116 14.359L14.491 15.4423L11.8327 13.909V10.834Z'
          fill='#171717'
        />
      </svg>
    ),
    view: false,
    complete: false,
  },
  {
    id: 4,
    text: 'Portfolios & Projects',
    icon: (
      <svg
        width='21'
        height='20'
        viewBox='0 0 21 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_2277_4698)'>
          <path
            d='M6.50016 14.6663C7.97292 14.6663 9.16683 13.4724 9.16683 11.9997C9.16683 10.5269 7.97292 9.33301 6.50016 9.33301C5.0274 9.33301 3.8335 10.5269 3.8335 11.9997C3.8335 13.4724 5.0274 14.6663 6.50016 14.6663Z'
            fill='black'
          />
          <path
            d='M12.8332 16.6663C13.7536 16.6663 14.4998 15.9201 14.4998 14.9997C14.4998 14.0792 13.7536 13.333 12.8332 13.333C11.9127 13.333 11.1665 14.0792 11.1665 14.9997C11.1665 15.9201 11.9127 16.6663 12.8332 16.6663Z'
            fill='black'
          />
          <path
            d='M13.1665 11.333C15.3756 11.333 17.1665 9.54215 17.1665 7.33301C17.1665 5.12387 15.3756 3.33301 13.1665 3.33301C10.9574 3.33301 9.1665 5.12387 9.1665 7.33301C9.1665 9.54215 10.9574 11.333 13.1665 11.333Z'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_2277_4698'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(0.5)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    view: false,
    complete: false,
  },
  {
    id: 5,
    text: 'Certificates & Achievements',
    icon: (
      <svg
        width='21'
        height='20'
        viewBox='0 0 21 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M7.33317 14.9993L10.6665 12.4577L13.9998 14.9993L12.6665 10.8952L15.9998 8.54102H11.9373L10.6665 4.31185L9.37484 8.54102H5.31234L8.64567 10.8952L7.33317 14.9993ZM10.6665 18.6243C9.48595 18.6243 8.37137 18.3987 7.32275 17.9473C6.27414 17.4959 5.35748 16.8778 4.57275 16.0931C3.78803 15.3084 3.16998 14.3952 2.71859 13.3535C2.2672 12.3118 2.0415 11.1938 2.0415 9.99935C2.0415 8.8049 2.2672 7.68338 2.71859 6.63477C3.16998 5.58615 3.78456 4.67296 4.56234 3.89518C5.34012 3.1174 6.25331 2.49935 7.30192 2.04102C8.35053 1.58268 9.47206 1.35352 10.6665 1.35352C11.8609 1.35352 12.9859 1.58268 14.0415 2.04102C15.0971 2.49935 16.0103 3.11393 16.7811 3.88477C17.5519 4.6556 18.1665 5.56532 18.6248 6.61393C19.0832 7.66254 19.3123 8.79102 19.3123 9.99935C19.3123 11.1938 19.0832 12.3153 18.6248 13.3639C18.1665 14.4125 17.5485 15.3257 16.7707 16.1035C15.9929 16.8813 15.0832 17.4959 14.0415 17.9473C12.9998 18.3987 11.8748 18.6243 10.6665 18.6243Z'
          fill='black'
        />
      </svg>
    ),
    view: false,
    complete: false,
  },
  {
    id: 6,
    text: 'Skills',
    icon: (
      <svg
        width='21'
        height='20'
        viewBox='0 0 21 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_2277_5000)'>
          <path
            d='M5.29167 18.7503C4.72222 18.7503 4.23958 18.5524 3.84375 18.1566C3.44792 17.7607 3.25 17.285 3.25 16.7295C3.25 16.16 3.44444 15.6809 3.83333 15.292C4.22222 14.9031 4.70139 14.7087 5.27083 14.7087C5.45139 14.7087 5.62153 14.7295 5.78125 14.7712C5.94097 14.8128 6.09722 14.8684 6.25 14.9378L8.64583 11.9795C8.39583 11.7017 8.22222 11.3996 8.125 11.0732C8.02778 10.7469 8.00694 10.4031 8.0625 10.042L4.5625 8.87533C4.38194 9.20866 4.13889 9.46908 3.83333 9.65658C3.52778 9.84408 3.17361 9.93783 2.77083 9.93783C2.21528 9.93783 1.73958 9.74338 1.34375 9.35449C0.947917 8.9656 0.75 8.48644 0.75 7.91699C0.75 7.34755 0.947917 6.86838 1.34375 6.47949C1.73958 6.0906 2.21528 5.89616 2.77083 5.89616C3.34028 5.89616 3.81944 6.0906 4.20833 6.47949C4.59722 6.86838 4.79167 7.34755 4.79167 7.91699C4.79167 7.97255 4.78819 8.01769 4.78125 8.05241C4.77431 8.08713 4.77083 8.12533 4.77083 8.16699L8.29167 9.37533C8.45833 9.04199 8.68056 8.77116 8.95833 8.56283C9.23611 8.35449 9.56944 8.2156 9.95833 8.14616V4.41699C9.43056 4.31977 9.02431 4.07671 8.73958 3.68783C8.45486 3.29894 8.3125 2.88227 8.3125 2.43783C8.3125 1.88227 8.50694 1.40658 8.89583 1.01074C9.28472 0.614909 9.76389 0.416992 10.3333 0.416992C10.9028 0.416992 11.3819 0.614909 11.7708 1.01074C12.1597 1.40658 12.3542 1.88227 12.3542 2.43783C12.3542 2.88227 12.2118 3.29894 11.9271 3.68783C11.6424 4.07671 11.2361 4.31977 10.7083 4.41699V8.14616C11.0972 8.2156 11.4306 8.35449 11.7083 8.56283C11.9861 8.77116 12.2153 9.04199 12.3958 9.37533L15.8958 8.16699C15.8819 8.13921 15.875 8.10449 15.875 8.06283V7.91699C15.875 7.34755 16.0694 6.86838 16.4583 6.47949C16.8472 6.0906 17.3194 5.89616 17.875 5.89616C18.4444 5.89616 18.9271 6.0906 19.3229 6.47949C19.7188 6.86838 19.9167 7.34755 19.9167 7.91699C19.9167 8.48644 19.7188 8.9656 19.3229 9.35449C18.9271 9.74338 18.4514 9.93783 17.8958 9.93783C17.5069 9.93783 17.1528 9.8406 16.8333 9.64616C16.5139 9.45171 16.2708 9.19477 16.1042 8.87533L12.6042 10.042C12.6736 10.4031 12.6562 10.7503 12.5521 11.0837C12.4479 11.417 12.2708 11.7087 12.0208 11.9587L14.4167 14.9378C14.5556 14.8684 14.7083 14.8128 14.875 14.7712C15.0417 14.7295 15.2153 14.7087 15.3958 14.7087C15.9653 14.7087 16.4444 14.9031 16.8333 15.292C17.2222 15.6809 17.4167 16.1531 17.4167 16.7087C17.4167 17.2781 17.2188 17.7607 16.8229 18.1566C16.4271 18.5524 15.9514 18.7503 15.3958 18.7503C14.8264 18.7503 14.3472 18.5559 13.9583 18.167C13.5694 17.7781 13.375 17.2989 13.375 16.7295C13.375 16.4656 13.4097 16.233 13.4792 16.0316C13.5486 15.8302 13.6736 15.6253 13.8542 15.417L11.4583 12.417C11.1389 12.6253 10.7639 12.7295 10.3333 12.7295C9.90278 12.7295 9.52778 12.6253 9.20833 12.417L6.8125 15.4378C6.97917 15.6323 7.10069 15.8302 7.17708 16.0316C7.25347 16.233 7.29167 16.4656 7.29167 16.7295C7.29167 17.2989 7.09722 17.7781 6.70833 18.167C6.31944 18.5559 5.84722 18.7503 5.29167 18.7503Z'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_2277_5000'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(0.333496)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    view: false,
    complete: false,
  },
  {
    id: 7,
    text: 'Others',
    icon: (
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.16667 9.52051C8.27778 9.52051 7.51389 9.20106 6.875 8.56217C6.23611 7.92329 5.91667 7.1594 5.91667 6.27051C5.91667 5.36773 6.23611 4.60037 6.875 3.96842C7.51389 3.33648 8.27778 3.02051 9.16667 3.02051C10.0694 3.02051 10.8368 3.33648 11.4688 3.96842C12.1007 4.60037 12.4167 5.36773 12.4167 6.27051C12.4167 7.1594 12.1007 7.92329 11.4688 8.56217C10.8368 9.20106 10.0694 9.52051 9.16667 9.52051ZM18.2708 19.2705L15.8958 16.8955C15.5764 17.1177 15.2465 17.274 14.9062 17.3643C14.566 17.4545 14.2153 17.4997 13.8542 17.4997C12.8542 17.4997 12 17.1455 11.2917 16.4372C10.5833 15.7288 10.2292 14.8747 10.2292 13.8747C10.2292 12.8608 10.5833 11.9997 11.2917 11.2913C12 10.583 12.8611 10.2288 13.875 10.2288C14.875 10.2288 15.7292 10.583 16.4375 11.2913C17.1458 11.9997 17.5 12.8608 17.5 13.8747C17.5 14.2219 17.4549 14.5656 17.3646 14.9059C17.2743 15.2462 17.1181 15.5761 16.8958 15.8955L19.2708 18.2705C19.4097 18.4094 19.4792 18.5726 19.4792 18.7601C19.4792 18.9476 19.4097 19.1177 19.2708 19.2705C19.1181 19.4094 18.9479 19.4788 18.7604 19.4788C18.5729 19.4788 18.4097 19.4094 18.2708 19.2705ZM13.8542 16.0622C14.4931 16.0622 15.0208 15.8538 15.4375 15.4372C15.8542 15.0205 16.0625 14.4997 16.0625 13.8747C16.0625 13.2358 15.8542 12.708 15.4375 12.2913C15.0208 11.8747 14.5 11.6663 13.875 11.6663C13.2361 11.6663 12.7083 11.8747 12.2917 12.2913C11.875 12.708 11.6667 13.2358 11.6667 13.8747C11.6667 14.4997 11.875 15.0205 12.2917 15.4372C12.7083 15.8538 13.2292 16.0622 13.8542 16.0622ZM3.79167 16.8538C3.40278 16.8538 3.06944 16.715 2.79167 16.4372C2.51389 16.1594 2.375 15.8261 2.375 15.4372V14.7705C2.375 14.2288 2.50347 13.767 2.76042 13.3851C3.01736 13.0031 3.38194 12.6872 3.85417 12.4372C4.50694 12.1177 5.37847 11.833 6.46875 11.583C7.55903 11.333 8.67361 11.208 9.8125 11.208C9.53472 11.5969 9.32986 12.0136 9.19792 12.458C9.06597 12.9025 9 13.3538 9 13.8122C9 14.3538 9.08681 14.8851 9.26042 15.4059C9.43403 15.9268 9.6875 16.4094 10.0208 16.8538H3.79167Z'
          fill='#171717'
        />
      </svg>
    ),
    view: false,
    complete: false,
  },
];

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SWITCH':
      return state.map((navitem) => {
        if (navitem.id === action.id) {
          return { ...navitem, view: true };
        } else {
          return { ...navitem, view: false };
        }
      });
    default:
      return state;
  }
};
